import { useCropImageStore } from '@/shared/store/useCropImageStore'
import { useSettingsModal } from '@/features/settings'
import { useWebsiteStore } from '../store/useWebsiteStore'

/**
 * Whether anything is open over this module's pages.
 *
 * Overlay scrollbars sit at z-index 30 and this app's modals at 5 and 6, so a
 * bar left rendered draws a bright line down whatever dialog is open. Every bar
 * in this module hides on this one flag.
 *
 * It has to read every store that opens one: the editor raises its own for the
 * row and element pickers, while the crop dialog and the settings modal are
 * shared with the rest of the app and know nothing about the editor's.
 */
export function useDialogOpen(): boolean {
  const editorDialogOpen = useWebsiteStore(state => state.dialogOpen)
  const cropOpen = useCropImageStore(state => state.isOpen)
  const settingsOpen = useSettingsModal(state => state.section !== null)
  return editorDialogOpen || cropOpen || settingsOpen
}

export default useDialogOpen
